import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {ModelImage} from '../../types/models';

interface PollImageInterface {
  img: ModelImage;
}

const PollImageContainer = styled.div`
  img {
    width: 100%;
  }
`;

const PollImage: React.FC<PollImageInterface> = ({img}) => {
  return (
    <PollImageContainer>
      <img src={img.url} alt={img.alt} />
    </PollImageContainer>
  );
};

export default PollImage;
